import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../../shared/base-api-template-service.model';
import { Core2Config } from '../../../shared/core2Config';
import { JobSalesOrderContainerModel } from '../../../../../../../models';
import { ApiVisa } from '../../../shared';

@Injectable({
  providedIn: 'root'
})
export class JobSalesOrderkService extends BaseApiTemplateService<any> {
  // https://api.akaun.cloud/core2/tnt/dm/del/job-docs/backoffice-ep/query

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-docs/backoffice-ep/query';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-docs/backoffice-ep/query';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-docs/backoffice-ep/query';
    this.httpClient = http;
  }

  cancelJobs(visa: ApiVisa, body: any) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-docs/cancel-job/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-docs/cancel-job/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    return this.httpClient.post(url, body, this.getHttpHeader(visa));
  }

  startJobs(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/start-jobs';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/start-jobs';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  startJobsLoginDriver(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/login-driver-ep/start-jobs';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/login-driver-ep/start-jobs';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  completeJobs(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/complete-jobs';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/complete-jobs';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  completeJobsLoginDriver(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/login-driver-ep/complete-jobs';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/login-driver-ep/complete-jobs';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  readyToShipJobs(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/ready-to-ship';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/ready-to-ship';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

}